export const Card = ({ children, className = "", ...rest }) => (
  <div className={`border border-border bg-card ${className}`} {...rest}>{children}</div>
);

export const StatCard = ({ label, value, sub, accent = "text-chalk", testid }) => (
  <Card className="p-5" data-testid={testid}>
    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-graphite">{label}</p>
    <p className={`font-anton text-3xl sm:text-4xl mt-2 ${accent}`}>{value}</p>
    {sub && <p className="font-mono text-[10px] uppercase tracking-wider text-graphite mt-2">{sub}</p>}
  </Card>
);

export const PageTitle = ({ title, sub, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
    <div>
      <h1 className="font-anton uppercase text-4xl">{title}</h1>
      {sub && <p className="text-graphite text-sm mt-2">{sub}</p>}
    </div>
    {children}
  </div>
);

export const STATUS_LABELS = {
  new: "New", in_review: "In Review", in_production: "In Production", shipped: "Shipped",
  delivered: "Delivered", cancelled: "Cancelled",
};

const STATUS_STYLES = {
  new: "text-signal border-signal/50",
  in_review: "text-violet-400 border-violet-400/50",
  in_production: "text-amber-400 border-amber-400/50",
  shipped: "text-sky-400 border-sky-400/50",
  delivered: "text-emerald-400 border-emerald-400/50",
  cancelled: "text-destructive border-destructive/50",
};

export const StatusBadge = ({ status }) => (
  <span className={`font-mono text-[9px] uppercase tracking-[0.2em] px-2 py-1 border whitespace-nowrap ${STATUS_STYLES[status] || "text-graphite border-border"}`}>
    {STATUS_LABELS[status] || status}
  </span>
);

export const fmtMoney = (v) => `$${(v || 0).toFixed(2)}`;
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—");
export const fmtDateTime = (d) => (d ? new Date(d).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "—");

export const Th = ({ children, className = "" }) => (
  <th className={`text-left font-mono text-[10px] uppercase tracking-[0.2em] text-graphite font-normal py-3 px-4 ${className}`}>{children}</th>
);
export const Td = ({ children, className = "", ...rest }) => (
  <td className={`py-3 px-4 text-sm ${className}`} {...rest}>{children}</td>
);

export const inputCls = "w-full bg-transparent border border-border px-3 py-2 font-mono text-sm focus:border-signal outline-none";
export const labelCls = "font-mono text-[10px] uppercase tracking-[0.25em] text-graphite block mb-1.5";
export const btnPrimary = "font-mono text-[11px] uppercase tracking-wider bg-signal text-ink px-5 py-2.5 hover:bg-signal/85 transition-colors disabled:opacity-50";
export const btnOutline = "font-mono text-[11px] uppercase tracking-wider border border-chalk px-5 py-2.5 hover:bg-chalk hover:text-ink transition-colors disabled:opacity-50";
export const btnGhost = "font-mono text-[11px] uppercase tracking-wider border border-border px-4 py-2 hover:border-chalk transition-colors disabled:opacity-50";

export const Modal = ({ open, onClose, children, wide = false }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[90] flex items-start justify-center overflow-y-auto p-4 sm:p-10" data-testid="admin-modal">
      <div className="fixed inset-0 bg-ink/80 backdrop-blur-sm" onClick={onClose} data-testid="admin-modal-overlay" />
      <div className={`relative bg-card border border-border w-full ${wide ? "max-w-4xl" : "max-w-2xl"} p-6 sm:p-8`}>
        <button onClick={onClose} data-testid="admin-modal-close"
          className="absolute top-4 right-4 font-mono text-xs text-graphite hover:text-pulse">✕ CLOSE</button>
        {children}
      </div>
    </div>
  );
};
